/* 
This vuex store is used to handle state, 
provide components with handy access to mutate vars,
and to initialize data objects
*/

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    step: null,
    nextStep: null,
    selected: null,
    customization: {
      // used to store input from Personalize steps
      introBlurb: null,
      headshot: null,
      outroCTA: null,
      outroPhone: null,
      outroEmail: null,
      videoTitle: null,
      srcVid: null,
      name: null,
      title: null,
    },
    customVideo: null,
    user: {
      uid: null,
    },
    srcVidIDs: [
      // mock data... this will come from a db in future
      "srcVid1",
      "srcVid2",
      "srcVid3",
      "srcVid4",
      "srcVid5",
      "srcVid6",
    ],
    videos: {
      // when we pull from the db of customized videos, we populate these
      // will need to adjust this when src videos become more dynamic
      srcVid1: {},
      srcVid2: {},
      srcVid3: {},
      srcVid4: {},
      srcVid5: {},
      srcVid6: {},
    },
    srcVideos: [
      // mock data... this will come from a db in future
      {
        id: "srcVid1",
        videoTitle: "Welcome to Guideline",
        largeURL:
          "https://drive.google.com/uc?export=download&id=1VxEpBMvpeeuHJkWdeXdjf-KRxJvFKwbO",
        thumbnail: "https://i.imgur.com/Lifvxjfm.png",
      },
      {
        id: "srcVid2",
        videoTitle: "What is a 401k?",
        largeURL:
          "https://drive.google.com/uc?export=download&id=1yWsrPxTOPx3CIbqtc6kNTDIjNzjxy2Bn",
        thumbnail: "https://i.imgur.com/A0V0BXhm.png",
      },
      {
        id: "srcVid3",
        videoTitle: "Contribution Types",
        largeURL:
          "https://drive.google.com/uc?export=download&id=1NxNx4W1LFhR66IGcRJGfMFv3iJwc2Szo",
        thumbnail: "https://i.imgur.com/791sTaQm.png",
      },
      {
        id: "srcVid4",
        videoTitle: "Set Up Your 401k",
        largeURL:
          "https://drive.google.com/uc?export=download&id=18a5o2_UnpLJOyUbOeLMbAzzVgN9rNWIx",
        thumbnail: "https://i.imgur.com/3GekpPcm.png",
      },
      {
        id: "srcVid5",
        videoTitle: "Your Guideline Account Dashboard",
        largeURL:
          "https://drive.google.com/uc?export=download&id=1dwjJ0TFIv8iS41L_EAI5tw_o-5ldSs5Y",
        thumbnail: "https://i.imgur.com/IhmjeWcm.png",
      },
      {
        id: "srcVid6",
        videoTitle: "Making Account Changes",
        largeURL:
          "https://drive.google.com/uc?export=download&id=1PYGtESmZumZyNUyif_hgUh6LPVCQzYIq",
        thumbnail: "https://i.imgur.com/uqmZPr5m.png",
      },
    ],
  },
  getters: {},
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    // video Personalization data functions
    changeStep(state, payload) {
      state.step = payload;
    },
    setNextStep(state, payload) {
      state.nextStep = payload;
    },
    changeHeadshot(state, payload) {
      state.customization.headshot = payload;
    },
    changeIntroBlurb(state, payload) {
      state.customization.introBlurb = payload;
    },
    changeOutroCTA(state, payload) {
      state.customization.outroCTA = payload;
    },
    changeOutroPhone(state, payload) {
      state.customization.outroPhone = payload;
    },
    changeOutroEmail(state, payload) {
      state.customization.outroEmail = payload;
    },
    changeVideoTitle(state, payload) {
      state.customization.videoTitle = payload;
    },
    changeName(state, payload) {
      state.customization.name = payload;
    },
    changeTitle(state, payload) {
      state.customization.title = payload;
    },
    setSrcVid(state, id) {
      state.customization.srcVid = id;
    },
    changeSelected(state, value) {
      state.selected = value;
    },
    setCustomVideo(state, value) {
      state.customVideo = value;
    },
    resetCustomization(state) {
      state.customization.headshot = null;
      state.customization.introBlurb = null;
      state.customization.outroCTA = null;
      state.customization.outroPhone = null;
      state.customization.outroEmail = null;
      state.customization.videoTitle = null;
      state.customization.name = null;
      state.customization.title = null;
      state.customVideo = null;
      state.step = 1;
    },
  },
  actions: {},
});
